const doc = [({"zh_tw":({"adminConstantHotelPlanBookingStatus":({"booked":"預訂確認通知", "requested":"預約申請"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;